// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var tooltipColors = function(mode) {
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        background: bg.tooltip,
        // icon, disabled.icon, hover.icon: trigger icon colors from Figma.
        // Not wired in Tooltip.tsx — MUI Tooltip has no slot for the trigger element.
        // Consumers should reference these directly: tooltipColors(mode).icon
        icon: ic.heavy,
        text: tx.white,
        disabled: {
            icon: ic.disabled
        },
        hover: {
            icon: ic.active
        }
    };
};

//# sourceMappingURL=tooltipColors.js.map